import Tree from './Tree.container';

export default Tree;
